import type { ComponentType } from 'react'
import type { SDIconProps } from '@/shared/icons/SDIcon'
import IconAlertTriangle from '@/shared/icons/NewDesign/IconAlertTriangle'
import IconArrowUpRight from '@/shared/icons/NewDesign/IconArrowUpRight'
import IconBan from '@/shared/icons/NewDesign/IconBan'
import IconCircleDashed from '@/shared/icons/NewDesign/IconCircleDashed'
import IconClock from '@/shared/icons/NewDesign/IconClock'
import IconFileCheck from '@/shared/icons/NewDesign/IconFileCheck'
import IconPen from '@/shared/icons/NewDesign/IconPen'
import IconPower from '@/shared/icons/NewDesign/IconPower'
import IconSend from '@/shared/icons/NewDesign/IconSend'

export type StatusTone = 'ok' | 'warn' | 'err' | 'info' | 'closed' | 'none'

interface StatusLook {
  tone: StatusTone
  Icon: ComponentType<SDIconProps>
}

const STATUS_LOOKS: Record<string, StatusLook> = {
  'Données client à renseigner': { tone: 'warn', Icon: IconClock },
  'Souscription web a finaliser': { tone: 'warn', Icon: IconClock },
  'Données compteur a renseigner': { tone: 'warn', Icon: IconClock },
  'BS complet': { tone: 'info', Icon: IconFileCheck },
  'Prêt pour la transmission': { tone: 'info', Icon: IconSend },
  Transféré: { tone: 'info', Icon: IconArrowUpRight },
  'Erreur lors du transfert': { tone: 'err', Icon: IconAlertTriangle },
  'Signé avec erreur': { tone: 'err', Icon: IconAlertTriangle },
  'Rétractation par le fournisseur': { tone: 'closed', Icon: IconBan },
  'Rétractation par Selectra': { tone: 'closed', Icon: IconBan },
  Signé: { tone: 'ok', Icon: IconPen },
  Activé: { tone: 'ok', Icon: IconPower },
}

export const resolveStatusLook = (status: string): StatusLook => {
  if (!status) return { tone: 'none', Icon: IconCircleDashed }
  return STATUS_LOOKS[status] ?? { tone: 'closed', Icon: IconCircleDashed }
}

export type PrestationTone = 'cdf' | 'mes' | 'other'

export const resolvePrestationTone = (situation: string): PrestationTone => {
  if (situation === 'cdf' || situation === 'mes') return situation
  return 'other'
}
